import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../pages/Dashboard/Sidebar/Sidebar";
import Loader from "../Loader/Loader";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { toastError, toastSuccess } from "../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import axios from "axios";
import config from "../../config/config";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CurrencySymbols from "../../common/CurrencySymbol";
import Select from "react-select";

const PosRegisterPage = () => {
  const {
    // currencyValues,
    registerConfig,
    registerId,
    fetchData,
    closeRegiterSummaryValidation,
    CurrencySymbol,
    FractionDigits,
  } = useContext(AppContext);
  const loginUserId = localStorage.getItem("ID") || "";

  const regId = registerId || 0;
  // const LocationVariable = localStorage.getItem("LocationVariable") || "{}"; // Ensure it's not null
  // const locationData = JSON.parse(LocationVariable); // Parse JSON string into object
  const Location = localStorage.getItem("Location"); // Get LocationName or empty string
  // const locationId = locationData.LocationID || ""; // Get LocationName or empty string
  const token = localStorage.getItem("Token") || "";
  const searchParams = new URLSearchParams(window.location.search);
  let type = searchParams.get("type");
  let queryId = searchParams.get("Id") || 0;
  const userRegisterId = localStorage.getItem("UserRegisterId") || 0;
  const paramObject = useParams();
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const [denominations, setDenominations] = useState([]);
  const [currencyValues, setCurrencyvalues] = useState([]);
  // const denominations = currencyValues.filter((value) => value !== "null");
  const [counts, setCounts] = useState(Array(denominations.length).fill(""));
  const [loading, setLoading] = useState(false);
  const [registerDetails, setRegisterDetails] = useState([]);
  const [masterRegisterList, setMasterRegisterList] = useState([]);
  const [givenNotes, setGivenNotes] = useState("");
  const [selectedMasterRegister, setSelectedMasterRegister] = useState({
    name: "",
    value: 0,
  });

  const [prevClosingAmounts, setPrevClosingAmounts] = useState({
    Cash: 0,
    Check: 0,
    GiftCard: 0,
    DebitCard: 0,
    CreditCard: 0,
  });
  const [amounts, setAmounts] = useState({
    Cash: 0,
    Check: 0,
    GiftCard: 0,
    DebitCard: 0,
    CreditCard: 0,
    CashClosing: 0,
    CheckClosing: 0,
    GiftCardClosing: 0,
    DebitCardClosing: 0,
    CreditCardClosing: 0,
  });

  const [paymentMethods, setPaymentMethods] = useState([]);

  const getApi = () => {
    if (queryId > 0) {
      let paramid = queryId;
      // Find By ID for register
      setLoading(true);
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/getposregisterdetailsbyid?registerId=${paramid}&locationId=${Location}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          let takeResData = res.data.ResponseData[0];
          setRegisterDetails(takeResData[0]);
          setSelectedMasterRegister({
            name: takeResData[0]?.RegisterName,
            value: takeResData[0]?.MasterRegisterId,
          });
          setLoading(false);
          setAmounts((prevState) => ({
            ...prevState,
            Cash: takeResData[0]?.CashOpenAmount
              ? parseFloat(takeResData[0].CashOpenAmount).toFixed(2)
              : "",
            Check: takeResData[0]?.CheckOpenAmount
              ? parseFloat(takeResData[0].CheckOpenAmount).toFixed(2)
              : "",
            GiftCard: takeResData[0]?.GiftCardOpenAmount
              ? parseFloat(takeResData[0].GiftCardOpenAmount).toFixed(2)
              : "",
            DebitCard: takeResData[0]?.DebitCardOpenAmount
              ? parseFloat(takeResData[0].DebitCardOpenAmount).toFixed(2)
              : "",
            CreditCard: takeResData[0]?.CreditCardOpenAmount
              ? parseFloat(takeResData[0].CreditCardOpenAmount).toFixed(2)
              : "",

            CashClosing:
              closeRegiterSummaryValidation === "false"
                ? (
                    (parseFloat(takeResData[0]?.CashOpenAmount) || 0) +
                    (parseFloat(takeResData[0]?.CashTotalAdditions) || 0) +
                    (parseFloat(takeResData[0]?.CashSales) || 0) -
                    (parseFloat(takeResData[0]?.CashTotalSubtractions) || 0)
                  ).toFixed(2)
                : 0,

            CheckClosing:
              closeRegiterSummaryValidation === "false"
                ? (
                    (parseFloat(takeResData[0]?.CheckOpenAmount) || 0) +
                    (parseFloat(takeResData[0]?.CheckTotalAdditions) || 0) +
                    (parseFloat(takeResData[0]?.CheckSales) || 0) -
                    (parseFloat(takeResData[0]?.CheckTotalSubtractions) || 0)
                  ).toFixed(2)
                : 0,

            GiftCardClosing:
              closeRegiterSummaryValidation === "false"
                ? (
                    (parseFloat(takeResData[0]?.GiftCardOpenAmount) || 0) +
                    (parseFloat(takeResData[0]?.GiftCardTotalAdditions) || 0) +
                    (parseFloat(takeResData[0]?.GiftCardSales) || 0) -
                    (parseFloat(takeResData[0]?.GiftCardTotalSubtractions) || 0)
                  ).toFixed(2)
                : 0,

            DebitCardClosing:
              closeRegiterSummaryValidation === "false"
                ? (
                    (parseFloat(takeResData[0]?.DebitCardOpenAmount) || 0) +
                    (parseFloat(takeResData[0]?.DebitCardTotalAdditions) || 0) +
                    (parseFloat(takeResData[0]?.DebitCardSales) || 0) -
                    (parseFloat(takeResData[0]?.DebitCardTotalSubtractions) ||
                      0)
                  ).toFixed(2)
                : 0,

            CreditCardClosing:
              closeRegiterSummaryValidation === "false"
                ? (
                    (parseFloat(takeResData[0]?.CreditCardOpenAmount) || 0) +
                    (parseFloat(takeResData[0]?.CreditCardTotalAdditions) ||
                      0) +
                    (parseFloat(takeResData[0]?.CreditCardSales) || 0) -
                    (parseFloat(takeResData[0]?.CreditCardTotalSubtractions) ||
                      0)
                  ).toFixed(2)
                : 0,
          }));

          // setAmounts((prevState) => ({
          //   ...prevState,
          //   Cash: takeResData[0]?.CashOpenAmount
          //     ? parseFloat(takeResData[0].CashOpenAmount).toFixed(2)
          //     : "",
          //   Check: takeResData[0]?.CheckOpenAmount
          //     ? parseFloat(takeResData[0].CheckOpenAmount).toFixed(2)
          //     : "",
          //   GiftCard: takeResData[0]?.GiftCardOpenAmount
          //     ? parseFloat(takeResData[0].GiftCardOpenAmount).toFixed(2)
          //     : "",
          //   DebitCard: takeResData[0]?.DebitCardOpenAmount
          //     ? parseFloat(takeResData[0].DebitCardOpenAmount).toFixed(2)
          //     : "",
          //   CreditCard: takeResData[0]?.CreditCardOpenAmount
          //     ? parseFloat(takeResData[0].CreditCardOpenAmount).toFixed(2)
          //     : "",
          //   CashClosing: takeResData[0]?.CashCloseAmount
          //     ? parseFloat(takeResData[0].CashCloseAmount).toFixed(2)
          //     : "",
          //   CheckClosing: takeResData[0]?.CheckCloseAmount
          //     ? parseFloat(takeResData[0].CheckCloseAmount).toFixed(2)
          //     : "",
          //   GiftCardClosing: takeResData[0]?.GiftCardCloseAmount
          //     ? parseFloat(takeResData[0].GiftCardCloseAmount).toFixed(2)
          //     : "",
          //   DebitCardClosing: takeResData[0]?.DebitCardCloseAmount
          //     ? parseFloat(takeResData[0].DebitCardCloseAmount).toFixed(2)
          //     : "",
          //   CreditCardClosing: takeResData[0]?.CreditCardCloseAmount
          //     ? parseFloat(takeResData[0].CreditCardCloseAmount).toFixed(2)
          //     : "",
          // }));
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  useState(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/getregistercurrencyvalues`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;

        console.log(responseData, "checkresponseData");

        const currencyLabels = responseData
          .filter((item) => item.CurrancyLabel !== "")
          .map((item) => item.CurrancyLabel);
        const currencyValues = responseData
          .filter((item) => item.CurrancyValue !== "")
          .map((item) => item.CurrancyValue);

        setDenominations(currencyLabels);
        setCurrencyvalues(currencyValues);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (type == "create") {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/getlastregisterclosingamounts?loginUserId=${loginUserId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          let takeResData = res.data.ResponseData[0];
          setPrevClosingAmounts((prevState) => ({
            ...prevState,
            Cash: takeResData?.PrevCashCloseAmount
              ? parseFloat(takeResData.PrevCashCloseAmount).toFixed(2)
              : "",
            Check: takeResData?.PrevCheckCloseAmount
              ? parseFloat(takeResData.PrevCheckCloseAmount).toFixed(2)
              : "",
            GiftCard: takeResData?.PrevGiftCardCloseAmount
              ? parseFloat(takeResData.PrevGiftCardCloseAmount).toFixed(2)
              : "",
            DebitCard: takeResData?.PrevDebitCardCloseAmount
              ? parseFloat(takeResData.PrevDebitCardCloseAmount).toFixed(2)
              : "",
            CreditCard: takeResData?.PrevCreditCardCloseAmount
              ? parseFloat(takeResData.PrevCreditCardCloseAmount).toFixed(2)
              : "",
          }));
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });

      axios
        .get(
          `${config.employeesBaseUrl}/employees/getmasterregisters?locationid=${Location}`, //pagination?.pageSize
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("checknnn", res.data.ResponseData);
          const regList = res.data.ResponseData.map((item) => {
            return {
              label: item.Name,
              value: item.ID,
            };
          });
          setMasterRegisterList(regList);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    getApi();

    const paymentMap = {
      TrackCashInRegister: "Cash",
      TrackChecksInRegister: "Check",
      TrackCreditCardsInRegister: "CreditCard",
      TrackDebitCardsInRegister: "DebitCard",
      TrackGiftcardsInRegister: "GiftCard",
    };

    const updatedPaymentMethods = registerConfig
      .filter(
        (config) =>
          config.AppConfigvalue === "true" && paymentMap[config.AppConfigkey]
      )
      .map((config) => paymentMap[config.AppConfigkey]);

    setPaymentMethods(updatedPaymentMethods);
  }, [registerConfig]);

  const handleTableInputChange = (index, value) => {
    const newCounts = [...counts];
    newCounts[index] = value;
    setCounts(newCounts);

    const totalCash = newCounts.reduce(
      (sum, count, idx) =>
        // sum + (Number(count) || 0) * denominations[idx].value,
        sum + (Number(count) || 0) * currencyValues[idx],
      0
    );

    if (type === "create") {
      setAmounts({ ...amounts, Cash: totalCash.toFixed(2) });
    } else {
      setAmounts({ ...amounts, CashClosing: totalCash.toFixed(2) });
    }
  };

  const handleRegisterChnage = (e) => {
    console.log(e, "ccccccc");
    setSelectedMasterRegister({ name: e.label, value: e.value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAmounts((prevAmounts) => ({
      ...prevAmounts,
      [name]: value, // Convert name to lowercase to match state keys toLowerCase()
    }));
    // setAmounts({ ...amounts, [e.target.name]: e.target.value });
  };

  const handleNotesChange = (e) => {
    setGivenNotes(e.target.value);
  };

  const signOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const callStoreConfigApi = (registerId) => {
    const formArray = [
      { AppConfigkey: "RegisterId", AppConfigvalue: registerId },
    ];
    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "REGISTER",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then(async (res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          setTimeout(() => {
            if (type == "create") {
              navigate("/pos");
            } else if (type == "edit") {
              navigate("/dashboard");
            }
          }, 500);
          // toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleConfirmationModal = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to close register?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, confirm it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleSubmit();
      } else {
        MySwal.close();
      }
    });
  };

  const handleSubmit = () => {
    if (type == "create" && selectedMasterRegister.value == 0) {
      toastError("Master Register is required");
      return;
    }
    let payloadData = {
      Id: type === "create" ? 0 : queryId,
      RegisterName: selectedMasterRegister.name,
      LoginEmployee: loginUserId,
      Notes: givenNotes,
      CashOpenAmount: amounts.Cash,
      CashCloseAmount: amounts.CashClosing,
      CheckOpenAmount: amounts.Check,
      CheckCloseAmount: amounts.CheckClosing,
      GiftCardOpenAmount: amounts.GiftCard,
      GiftCardCloseAmount: amounts.GiftCardClosing,
      DebitCardOpenAmount: amounts.DebitCard,
      DebitCardCloseAmount: amounts.DebitCardClosing,
      CreditCardOpenAmount: amounts.CreditCard,
      CreditCardCloseAmount: amounts.CreditCardClosing,
      Curr1counts: counts[0] || "",
      Curr2counts: counts[1] || "",
      Curr3counts: counts[2] || "",
      Curr4counts: counts[3] || "",
      Curr5counts: counts[4] || "",
      Curr6counts: counts[5] || "",
      Curr7counts: counts[6] || "",
      Curr8counts: counts[7] || "",
      Curr9counts: counts[8] || "",
      Curr10counts: counts[9] || "",
      Curr11counts: counts[10] || "",
      Curr12counts: counts[11] || "",
      Curr13counts: counts[12] || "",
      Curr14counts: counts[13] || "",
      Curr15counts: counts[14] || "",
      Curr16counts: counts[15] || "",
      Curr17counts: counts[16] || "",
      Curr18counts: counts[17] || "",
      Curr19counts: counts[18] || "",
      Curr20counts: counts[19] || "",
      registerType: type,
      masterregisterid: selectedMasterRegister.value,
      locationid: Location,
    };

    setLoading(true);

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/posregisterupsert`,
        payloadData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (type === "create") {
            // localStorage.setItem("registerId", res.data.ResponseData[0].ID);
            localStorage.setItem("UserRegisterId", res.data.ResponseData[0].ID);
            callStoreConfigApi(res.data.ResponseData[0].ID);
            // navigate("/pos");
          } else if (type === "edit") {
            navigate(`/register_log_details/${res.data.ResponseData[0].ID}`);
          } else if (type === "close") {
            localStorage.removeItem("UserRegisterId", 0);
            callStoreConfigApi(0);
            navigate("/dashboard");
            window.location.reload();
          }
          toastSuccess(SUCCESS_MESSAGE);
          setLoading(false);
          // navigate(`/sales-receipt/${res.data.ResponseID}`);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={regId > 0 ? "/pos" : "/posregister?type=create"}>
                    Sales
                  </Link>
                </li>
                {/* <li className="breadcrumb-item active">Manage Employee</li> */}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className={"col-lg-12 col-md-12"}>
              <div className="card bg-white">
                {/* <div className="p-4 max-w-2xl mx-auto bg-white shadow rounded-lg"> */}
                <div className="card-body">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">
                      {type === "create"
                        ? "Please enter an opening amount to get in the sales register"
                        : "Before you can get out of the sales register, you must enter a closeout amount."}
                    </h2>
                    {type != "create" && (
                      <Link
                        to={`/register_log_details/${registerDetails.Id}`}
                        className="text-blue-400 mt-5 fs-3 font-semibold ml-auto"
                        title="View Details"
                      >
                        Details
                      </Link>
                    )}
                  </div>
                  {type === "create" && (
                    <>
                      <label className="ms-2">Select Master Register<span className="text-danger">*</span></label>
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        placeholder="Select register"
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="masterreg"
                        name="masterreg"
                        className="custom-search-select col-3"
                        options={masterRegisterList}
                        onChange={(e) => handleRegisterChnage(e)}
                      />
                    </>
                  )}
                  <hr></hr>

                  <div className="col-md-12 d-flex gap-4">
                    <div className="col-md-4">
                      <table className="w-full border-collapse border border-gray-300">
                        <thead>
                          <tr>
                            <th className="border p-2">Denomination</th>
                            <th className="border p-2">Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {denominations.map((denomination, index) => (
                            <tr key={index}>
                              <td className="border text-center p-2">
                                {denomination}
                              </td>
                              <td className="border p-2">
                                <input
                                  type="number"
                                  className="w-full border p-3"
                                  value={counts[index]}
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) =>
                                    handleTableInputChange(
                                      index,
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {type == "create" && (
                      <div className="col-md-8">
                        {paymentMethods.map((key, index) => (
                          <div key={index} className="mb-3">
                            <p className="block font-medium mb-1 text-center">
                              Previous Closing Amount:{" "}
                              {CurrencySymbols(
                                Number(prevClosingAmounts[key]),
                                { CurrencySymbol },
                                FractionDigits
                              )}
                            </p>

                            <label className="form-label text-center capitalize">
                              {key.replace(/([A-Z])/g, " $1")} Opening Amount:
                            </label>
                            <input
                              type="text"
                              name={key}
                              value={amounts[key] || 0}
                              onChange={handleChange}
                              onFocus={(e) => e.target.select()}
                              className="w-full border p-3 rounded"
                            />
                            <hr className="my-2 mt-4" />
                          </div>
                        ))}
                        <button
                          className="btn btn-sm btn-primary pull-right"
                          onClick={() => handleSubmit()}
                        >
                          Save
                        </button>
                      </div>
                    )}
                    {(type == "close" || type == "edit") && (
                      <div className="col-md-8">
                        {paymentMethods.map((method, index) => {
                          // Dynamically get values from registerDetails
                          const openAmount = parseFloat(
                            registerDetails[`${method}OpenAmount`] || "0"
                          ).toFixed(2);

                          const sales = parseFloat(
                            registerDetails[`${method}Sales`] || "0"
                          ).toFixed(2);
                          const totalAdditions = parseFloat(
                            registerDetails[`${method}TotalAdditions`] || "0"
                          ).toFixed(2);
                          const totalSubtractions = parseFloat(
                            registerDetails[`${method}TotalSubtractions`] || "0"
                          ).toFixed(2);
                          const totalOverShort = parseFloat(
                            (
                              Number(
                                registerDetails?.[`${method}OpenAmount`] || 0
                              ) +
                              Number(
                                registerDetails?.[`${method}TotalAdditions`] ||
                                  0
                              ) +
                              Number(registerDetails?.[`${method}Sales`] || 0) -
                              Number(
                                registerDetails?.[
                                  `${method}TotalSubtractions`
                                ] || 0
                              )
                            ).toFixed(2)
                          );

                          // const totalOverShort =
                          // parseFloat((registerDetails[`${method}OpenAmount`] || 0 +
                          //   registerDetails[`${method}TotalAdditions`] || 0 +
                          //   registerDetails[`${method}Sales`] || 0) -
                          //   registerDetails[`${method}TotalSubtractions`] || 0).toFixed(2);

                          return (
                            <div>
                              {closeRegiterSummaryValidation === "false" && (
                                <table className="col-md-11 border-collapse border border-gray-700 ml-auto">
                                  <tbody>
                                    <tr className="border-b border-gray-600">
                                      <td className="p-2 font-semibold">
                                        {method} Open Amount:
                                      </td>
                                      <td className="p-2 text-right">
                                        {/* ${openAmount} */}
                                        {CurrencySymbols(
                                          Number(openAmount),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}
                                      </td>
                                    </tr>
                                    <tr className="border-b border-gray-600">
                                      <td className="p-2 font-semibold">
                                        {method} Sales:
                                      </td>
                                      <td className="p-2 text-right">
                                        {/* ${sales} */}
                                        {CurrencySymbols(
                                          Number(sales),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}
                                      </td>
                                    </tr>
                                    <tr className="border-b border-gray-600">
                                      <td className="p-2 font-semibold">
                                        {method} Total Additions:
                                        {type === "close" && (
                                          <Link
                                            to={`/register_add_subtract?type=add&method=${method}`}
                                            className="text-blue-400 underline ml-2"
                                            title="Add amount"
                                          >
                                            [Edit]
                                          </Link>
                                        )}
                                      </td>
                                      <td className="p-2 text-right">
                                        {/* ${totalAdditions} */}
                                        {CurrencySymbols(
                                          Number(totalAdditions),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}
                                      </td>
                                    </tr>
                                    <tr className="border-b border-gray-600">
                                      <td className="p-2 font-semibold">
                                        {method} Total Subtractions:
                                        {type === "close" && (
                                          <Link
                                            to={`/register_add_subtract?type=remove&method=${method}`}
                                            className="text-blue-400 underline ml-2"
                                            title="Remove amount"
                                          >
                                            [Edit]
                                          </Link>
                                        )}
                                      </td>
                                      <td className="p-2 text-right">
                                        {/* ${totalSubtractions} */}
                                        {CurrencySymbols(
                                          Number(totalSubtractions),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}
                                      </td>
                                    </tr>
                                    <tr className="border-b border-gray-600">
                                      <td className="p-2 font-semibold">
                                        You should have in the register:
                                      </td>
                                      <td className="p-2 text-right text-green-500 font-bold">
                                        {/* $
                                        {(
                                          parseFloat(openAmount) +
                                          parseFloat(totalAdditions) +
                                          parseFloat(sales) -
                                          parseFloat(totalSubtractions)
                                        ).toFixed(2)} */}
                                        {CurrencySymbols(
                                          Number(totalOverShort),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="p-2 font-semibold">
                                        Total Over/Short:
                                      </td>
                                      <td className="p-2 text-right">
                                        {CurrencySymbols(
                                          Number(totalOverShort),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}

                              {/* Opening Amount Input */}
                              {type === "edit" && (
                                <>
                                  <label className="form-label capitalize mt-2 block">
                                    {method} Opening Amount:
                                  </label>
                                  <input
                                    type="text"
                                    name={method}
                                    value={amounts[method] || ""}
                                    onChange={handleChange}
                                    className="w-full border p-3 rounded"
                                    onFocus={(e) => e.target.select()}
                                  />
                                </>
                              )}

                              {/* Closing Amount Input */}
                              <label className="form-label capitalize mt-2 block">
                                {method} Closing Amount:
                              </label>
                              <input
                                type="text"
                                className="w-full border p-3 rounded mt-1 mb-2"
                                name={`${method}Closing`}
                                value={amounts[`${method}Closing`] || 0}
                                // value={type === "close" ? totalOverShort : amounts[`${method}Closing`] || ""}
                                onChange={handleChange}
                                onFocus={(e) => e.target.select()}
                              />
                              <hr></hr>
                            </div>
                          );
                        })}
                        <label className="form-label capitalize mt-2 block">
                          Notes
                        </label>
                        <textarea
                          // type="textarea"
                          className="w-full border p-3 rounded mt-1"
                          onChange={(e) => handleNotesChange(e)}
                        />

                        <button
                          type="button"
                          className="btn btn-sm btn-primary  mt-3"
                          // data-bs-toggle="modal"
                          // data-bs-target="#staticBackdrop"
                          onClick={() => handleConfirmationModal()}
                        >
                          Submit
                        </button>
                        {type === "close" && (
                          <div className="pull-right">
                            <h6 className="text-lg mb-4 mt-4">OR</h6>
                            <button
                              className="bg-red-500 hover:bg-red-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition-all"
                              onClick={() => {
                                signOut();
                              }}
                            >
                              Logout without closing register (Next employee
                              will close)
                            </button>
                          </div>
                        )}

                        {/* <div
                            class="modal fade"
                            id="staticBackdrop"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabindex="-1"
                            aria-labelledby="staticBackdropLabel"
                            aria-hidden="true"
                          >
                            <div class="modal-dialog">
                              <div class="modal-content">
                                <div class="modal-body">
                                  <button
                                    type="button"
                                    class="btn-close pull-right text-black"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                  Are you sure you want to close register?
                                </div>
                                <div class="modal-footer">
                                  <button
                                    type="button"
                                    class="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-primary"
                                    onClick={() => handleSubmit()}
                                  >
                                    Ok
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div> */}
                      </div>
                    )}
                  </div>
                  {/* <div className="text-center mt-4">
                    <p className="text-lg font-semibold">OR</p>
                    <p className="text-gray-700">
                      Register Name:{" "}
                      <span className="text-blue-600">Default</span>{" "}
                      <a href="#" className="text-blue-500">
                        (Change Register)
                      </a>
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PosRegisterPage;
